import { Button } from '@mui/material';

import { ResetGridStateButtonProps } from './types';

export const ResetGridStateButton = ({
  isDirty,
  onReset,
}: ResetGridStateButtonProps) => {
  if (!isDirty) return null;

  return (
    <Button
      size="small"
      onClick={onReset}
      variant="outlined"
      sx={{ ml: 'auto' }}
    >
      Reset View
    </Button>
  );
};
